import { render, staticRenderFns } from "./MacaoGifted.vue?vue&type=template&id=65eb886f&scoped=true&"
import script from "./MacaoGifted.vue?vue&type=script&lang=js&"
export * from "./MacaoGifted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb886f",
  null
  
)

export default component.exports